import * as React from "react";

const s = require("./primary.scss");

interface Props {
    type?: string;
    onClick?: () => any;
    children?: JSX.Element;
}

function PrimaryButton(props: Props) {
    return (
        <button type={props.type || "submit"} className={s.submitButton} onClick={props.onClick}>
            {props.children}
        </button>
    );
}

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/components/FormElements/Buttons/Primary/index.tsx